import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vs',
  templateUrl: './vs.component.html',
  styleUrls: ['./vs.component.scss'],
})
export class VS implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
